<!--
    Summary:
        firstchoice.exhibition.web - mthfr-p1
    ChangeLog:
        wangn on 2020/12/6 added
-->
<template>
    <div class="v-mthfr-p1" title="mthfr-p1">
      <h2 class="h2" style="text-align: center; color: #cb3439; text-shadow: 1px 1px 2px #ffffff;">{{$t('Mthfr.P1_Title')}}</h2>
      <p>&nbsp;</p>
      <h5 class="h5" style="text-align: center; color: #ffffff; text-shadow: 1px 1px 2px #cb3439;">{{$t('Mthfr.P1_SubTitle')}}</h5>
    </div>
</template>

<script>
    export default {
        name: "mthfr-p1"
    }
</script>

<style scoped lang="scss">
    .v-mthfr-p1 {
      background-color: #e699b2;
      padding-top: 30px;
      padding-bottom: 30px;
    }
</style>




// WEBPACK FOOTER //
// src/view/genedetection/mthfr/mthfr-p1.vue